import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { DeleteCorporateButton } from './DeleteCorporateButton.component'
import { Corporate } from '../../../../../../../entities-next/corporate'

export type CorporateTableActionsProps = ExtendableStyles &
  Testable & {
    corporate: Corporate
  }

export function CorporateTableActions({ className, corporate }: CorporateTableActionsProps) {
  const { classes } = useStyles()

  return (
    <div className={classNames(className, classes.actionCell)}>
      <DeleteCorporateButton className={classes.actionButton} corporate={corporate} />
    </div>
  )
}

const useStyles = makeStyles()(({ palette, spacing }) => ({
  actionCell: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    width: spacing(5.5),
    height: spacing(5.5),
  },
  testingUserChip: {
    marginRight: spacing(-0.5),
    color: palette.common.white,
    backgroundColor: palette.primary.main,
  },
}))
